module.exports = __webpack_public_path__ + "img/pic3.78a800bb.png";